module.exports = __webpack_public_path__ + "img/icon-arrow-right.9838d61a.svg";